import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'energyUnit',
  standalone: false,
})
export class EnergyUnitPipe implements PipeTransform {
  transform(value: number | string | null | undefined, decimals: number = 2): string {
    // 1. Handle edge cases gracefully
    if (value === null || value === undefined || isNaN(Number(value))) {
      return '0 Wh';
    }

    let numValue = Number(value);

    // 2. Define the scale metrics
    const units = ['Wh', 'kWh', 'MWh', 'GWh', 'TWh', 'PWh'];

    if (numValue === 0) return `0 ${units[0]}`;

    // 3. Find the matching power index (i.e. floor of log base 1000)
    const i = Math.floor(Math.log(Math.abs(numValue)) / Math.log(1000));

    // Safety check to avoid index out of bounds for insanely high values
    const unitIndex = Math.min(i, units.length - 1);

    // 4. Scale down the number
    const scaled = numValue / Math.pow(1000, unitIndex);

    // 5. Format to custom decimals and strip unnecessary trailing zeros
    const formattedNumber = parseFloat(scaled.toFixed(decimals));

    return `${formattedNumber} ${units[unitIndex]}`;
  }
}
